// Convert local development URLs to app routes so they also work after deploy.
const LOCAL_HOSTS = new Set(['localhost', '127.0.0.1', '0.0.0.0']);

export const resolveBannerLink = (value) => {
  const link = String(value || '').trim();
  if (!link) return null;
  if (link.startsWith('/')) return { internal: true, to: link };

  try {
    const url = new URL(link, window.location.origin);
    if (!['http:', 'https:'].includes(url.protocol)) return null;
    const isLocalDevUrl = LOCAL_HOSTS.has(url.hostname) && /^\/(book|shop|stores|offers|cart|login|register)(\/|$)/i.test(url.pathname);
    if (url.origin === window.location.origin || isLocalDevUrl) {
      return { internal: true, to: `${url.pathname}${url.search}${url.hash}` };
    }
    return { internal: false, href: url.href };
  } catch {
    return null;
  }
};
